<template>
  <div
    :class="{
      [headingClass]: true,
      'justify-center': headingType !== HEADING_TYPES.DEFAULT,
      'justify-center': headingType === HEADING_TYPES.DEFAULT && headingAlign === TEXT_ALIGN_OPTIONS.CENTER,
      'justify-start': headingType === HEADING_TYPES.DEFAULT && headingAlign === TEXT_ALIGN_OPTIONS.LEFT,
      'justify-end': headingType === HEADING_TYPES.DEFAULT && headingAlign === TEXT_ALIGN_OPTIONS.RIGHT,
      'q-px-sm': isMobileView
    }"
    :style="headingStyle"
  >
    <span
      v-if="showLeftCol"
      class="col q-ml-none"
      :style="setHeadingStyle"
      style="-webkit-transform: scaleX(-1);transform: scaleX(-1);"
    />
    <p
      class="col-auto q-mb-none"
      :class="{
        'text-white': lightText,
        [`text-${fontSize}`]: true,
        [`text-${textAlign}`]: true,
        'full-width': headingType === HEADING_TYPES.DEFAULT && isMobileView,
        'text-primary': isMoviePage || ($register && !customizeRegisterView),
        'q-pr-md': headingType !== HEADING_TYPES.DEFAULT && headingAlign !== TEXT_ALIGN_OPTIONS.RIGHT,
        'q-pl-md': headingType !== HEADING_TYPES.DEFAULT && headingAlign !== TEXT_ALIGN_OPTIONS.LEFT,
        'text-center': headingAlign === TEXT_ALIGN_OPTIONS.CENTER || !headingAlign && isMobileView

      }"
      :style="titleStyle"
    >
      {{ title }}
      <slot name="icon" />
      <br v-if="showSiteSelector && fontSize !== 'h4'">
      <span
        v-if="showSiteSelector"
        class="text-h4 q-pr-sm"
      >{{ $t('common.at') }}</span>
      <site-selector-zones-selectbox
        v-if="showSiteSelector"
        class="row inline-block"
        hide-icon
        flat
        size="lg"
        padding="none sm"
        dense
        style="border-bottom: 1px solid; border-radius: 0;"
        :style="{ 'margin-top': marginTop }"
      />
    </p>
    <span
      v-if="showRightCol"
      class="col"
      :style="setHeadingStyle"
    />
  </div>
</template>

<script>

import { TEXT_ALIGN_OPTIONS } from 'src/models/carousel/Carousel'
import { HEADING_TYPES } from 'src/models/page/Section'
import SiteSelectorZonesSelectbox from 'src/modules/consumer/components/site-selector/SiteSelectorZonesSelectbox'
export default {
  name: 'SectionHeading',
  components: { SiteSelectorZonesSelectbox },
  props: {
    headingColor: {
      type: String,
      default: 'primary',
      required: false
    },
    headingColorHex: {
      type: String,
      default: '#FFFFFF',
      required: false
    },
    headingType: {
      type: String,
      default: HEADING_TYPES.DEFAULT,
      required: false
    },
    headingFontSize: {
      type: String,
      default: null,
      required: false
    },
    headingAlign: {
      type: String,
      default: null,
      required: false
    },
    headingBackgroundImageUrl: {
      type: String,
      default: null,
      required: false
    },
    headingBackgroundImageRepeat: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileView: {
      type: Boolean,
      required: false,
      default: false
    },
    lightText: {
      type: Boolean,
      required: false,
      default: false
    },
    checkout: {
      type: Boolean,
      required: false,
      default: false
    },
    showSiteSelector: {
      type: Boolean,
      required: false,
      default: false
    },
    isMoviePage: {
      type: Boolean,
      required: false,
      default: false
    },
    customizeRegisterView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    showLeftCol () {
      return this.headingType !== HEADING_TYPES.DEFAULT && (this.headingAlign === TEXT_ALIGN_OPTIONS.CENTER || this.headingAlign === TEXT_ALIGN_OPTIONS.RIGHT || !this.headingAlign)
    },
    showRightCol () {
      return this.headingType !== HEADING_TYPES.DEFAULT && (this.headingAlign === TEXT_ALIGN_OPTIONS.CENTER || this.headingAlign === TEXT_ALIGN_OPTIONS.LEFT || !this.headingAlign)
    },
    setHeadingStyle () {
      if (this.headingType === HEADING_TYPES.DEFAULT || !this.headingType) return null
      const setHeadingStyle = []
      const templateStyle = [HEADING_TYPES.VALENTINES1, HEADING_TYPES.VALENTINES2]
      if (this.headingType === HEADING_TYPES.LINE1) {
        const heading = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
        if (_.includes(heading, this.fontSize)) {
          setHeadingStyle.push('width: auto; height: 1px; border: 2px solid')
        } else {
          setHeadingStyle.push('width: auto; height: 1px; border-top: 1px solid')
        }
      }
      if (this.headingType === HEADING_TYPES.LINE2) {
        setHeadingStyle.push('width: auto; height: 8px; border-top: 2px solid; border-bottom: 2px solid')
      }
      if (templateStyle.includes(this.headingType)) {
        setHeadingStyle.push('width: 100%; height: 25px; background-position: left center; background-size: auto; background-image:' +
         `url(/images/consumer/heading/${this.headingType.replace(/\s+/g, '').toLowerCase()}.png)`)
      }
      if (this.headingType === HEADING_TYPES.CUSTOM && !!this.headingBackgroundImageUrl) {
        setHeadingStyle.push('width: 100%; height: 25px; background-position: left center; background-size: auto; background-image:' +
        `url(${this.headingBackgroundImageUrl})`)
      }

      if (this.headingBackgroundImageRepeat) {
        setHeadingStyle.push('background-repeat: repeat-x;')
      } else {
        setHeadingStyle.push('background-repeat: no-repeat;')
      }
      return setHeadingStyle.join(';')
    },
    headingClass () {
      const headingClasses = []

      headingClasses.push('row items-center self-center')

      if (this.headingColor && this.headingColor !== 'custom' && !this.lightText) {
        headingClasses.push('text-' + this.headingColor)
      }

      if (this.lightText) {
        headingClasses.push('text-white')
      }

      return headingClasses.join(' ')
    },

    headingStyle () {
      const headingStyle = []

      if (this.headingColor === 'custom' && this.headingColorHex) {
        headingStyle.push('color: ' + this.headingColorHex)
      }

      return headingStyle.join(';')
    },
    fontSize () {
      if (!this.isMoviePage && !!this.headingFontSize) return this.headingFontSize
      return 'h2'
    },
    textAlign () {
      if (this.headingAlign) return this.headingAlign
      if (this.headingType !== HEADING_TYPES.DEFAULT && !!this.headingType) return 'center'
      if (this.isMobileView) return 'center'
      return 'left'
    },
    titleStyle () {
      if (this.isMoviePage || (this.$register && !this.headingFontSize)) return 'font-size: 32px; line-height: 1.5rem; padding: 16px 8px 16px 0;'
      if (this.checkout) return 'font-size: 18px; line-height: 1.5'
      if (this.isMobileView && this.headingType !== HEADING_TYPES.DEFAULT) return 'max-width: 80%'
      return false
    },
    marginTop () {
      if (this.fontSize === 'h1') return '16px'
      if (this.fontSize === 'h5') return '-12px'
      if (this.fontSize === 'h6') return '-14px'
      return '0'
    }
  },
  configuration: ['currentSite'],
  created () {
    _.extend(this, { TEXT_ALIGN_OPTIONS, HEADING_TYPES })
  }
}
</script>
